import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MemberProfile, ProfileCommand, RELATIONSHIPS } from '../domain/member-profile';

@Component({ selector: 'app-emergency-contact-editor', imports: [FormsModule], templateUrl: './emergency-contact-editor.component.html' })
export class EmergencyContactEditorComponent implements OnInit {
  @Input({ required: true }) member!: Readonly<MemberProfile>;
  @Input() busy = false;
  @Input() blocked = false;
  @Output() submitted = new EventEmitter<ProfileCommand>();
  @Output() cancel = new EventEmitter<void>();
  newEmLastName = ''; newEmFirstName = ''; newEmLastNameKana = ''; newEmFirstNameKana = '';
  newEmRelationship: { id: number; name: string } | null = null;
  newEmPhone1 = ''; newEmPhone2 = ''; newEmPhone3 = '';
  readonly relationships = RELATIONSHIPS.map((name, id) => ({ id, name }));
  ngOnInit(): void {
    const m = this.member;
    this.newEmLastName = m.emLastName; this.newEmFirstName = m.emFirstName;
    this.newEmLastNameKana = m.emLastNameKana; this.newEmFirstNameKana = m.emFirstNameKana;
    this.newEmRelationship = this.relationships.find(r => r.id === m.emRelationship) ?? null;
    [this.newEmPhone1 = '', this.newEmPhone2 = '', this.newEmPhone3 = ''] = m.emPhone.split('-');
  }
  submit(form: NgForm): void {
    if (form.invalid || form.pending || this.busy || this.blocked) return;
    this.submitted.emit({ kind: 'emergency', value: {
      emLastName: this.newEmLastName, emFirstName: this.newEmFirstName,
      emLastNameKana: this.newEmLastNameKana, emFirstNameKana: this.newEmFirstNameKana,
      emRelationship: this.newEmRelationship?.id ?? null,
      emPhone: `${this.newEmPhone1}-${this.newEmPhone2}-${this.newEmPhone3}`,
    } });
  }
}
